import { ASSETS } from "@/lib/site";
import { Award, BookOpen, Shield, Users } from "lucide-react";

const CREDS = [
  { icon: Shield, label: "USAF Veteran" },
  { icon: BookOpen, label: "M.A. Human Development" },
  { icon: Users, label: "Behavioral Consultant" },
  { icon: Award, label: "Published Author" },
];

export default function About() {
  return (
    <section id="about" className="relative bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {/* Image */}
        <div className="lg:col-span-5 relative">
          <div className="absolute -top-6 -right-6 w-40 h-40 bg-gold/15 hidden md:block" />
          <div className="relative w-full bg-mist">
            <img
              src={ASSETS.family}
              alt="CDaught with his family"
              data-testid="about-portrait"
              className="relative w-full h-auto object-contain"
            />
          </div>
          <div className="hidden md:flex absolute -bottom-5 -left-5 bg-white border border-[hsl(var(--line))] p-4 items-center gap-3 shadow-sm">
            <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center text-gold font-serif font-bold">
              CD
            </div>
            <div>
              <div className="text-[13px] font-semibold text-navy">CDaught</div>
              <div className="text-[11px] text-navy/55 tracking-wide">Founder, CDaught Speaks LLC</div>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-7">
          <div className="eyebrow text-gold">Meet CDaught</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-navy mt-3 font-bold leading-[1.05] tracking-tight">
            A husband, a father, a veteran —
            <span className="block italic font-medium text-gold">and a voice schools trust.</span>
          </h2>

          <div className="mt-8 space-y-5 text-[15px] text-navy/75 leading-relaxed max-w-xl">
            <p>
              CDaught is a husband, father, mentor, USAF veteran, educator, author, behavioral
              consultant, and speaker dedicated to helping individuals and organizations grow
              through communication, accountability, and relationship building.
            </p>
            <p>
              He holds a Bachelor&apos;s degree in Communication from <em>Abilene Christian University</em>{" "}
              and a Master&apos;s in Human Development from <em>Hardin-Simmons University</em>.
            </p>
            <p>
              As the founder of <strong className="text-navy">CDaught Speaks</strong> and{" "}
              <strong className="text-navy">From Boys to Gentlemen</strong>, he has spent years
              helping students, educators, parents, and communities create environments where
              growth becomes possible — and inevitable.
            </p>
          </div>

          <div className="mt-9 grid grid-cols-2 gap-4 max-w-lg">
            {CREDS.map((c) => (
              <div
                key={c.label}
                data-testid={`cred-${c.label}`}
                className="flex items-center gap-3 border border-[hsl(var(--line))] px-4 py-3 hover:border-navy/40 transition-colors"
              >
                <c.icon size={18} className="text-gold" strokeWidth={1.6} />
                <span className="text-[13px] font-medium text-navy">{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
